module.exports = __webpack_public_path__ + "static/media/gallery.67c255b8.svg";